export const DAY_WEIGHT_KEYS = ["earlyMorning", "morning", "afternoon", "evening"];

// Percent shares of each six-hour block, matching the demand engine.
export function defaultDemandWeights(useCase = "Commercial") {
  const values = useCase === "Commercial" ? [5, 35, 45, 15] : [12.5, 25, 35, 27.5];
  return Object.fromEntries(DAY_WEIGHT_KEYS.map((key, i) => [key, values[i]]));
}

export function hasDemandWeights(weights = {}) {
  return DAY_WEIGHT_KEYS.some((key) => weights[key] != null && String(weights[key]).trim() !== "");
}

export function displayedDemandWeights(weights, useCase) {
  return hasDemandWeights(weights) ? weights : defaultDemandWeights(useCase);
}

export function weightsForProfileChange(weights, previousType, nextType) {
  // Selecting a different preset replaces the previous shape, including edits.
  // Subsequent manual edits remain in place until another preset is selected.
  return previousType === nextType ? { ...weights } : defaultDemandWeights(nextType);
}
